import { render, staticRenderFns } from "./DexHeaderNavSection.vue?vue&type=template&id=1b72e612&scoped=true&"
import script from "./DexHeaderNavSection.vue?vue&type=script&lang=js&"
export * from "./DexHeaderNavSection.vue?vue&type=script&lang=js&"
import style0 from "./DexHeaderNavSection.vue?vue&type=style&index=0&id=1b72e612&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b72e612",
  null
  
)

export default component.exports